import { render, staticRenderFns } from "./AddCall.vue?vue&type=template&id=60efb7d1&"
import script from "./AddCall.vue?vue&type=script&lang=js&"
export * from "./AddCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports